module.exports = __webpack_public_path__ + "static/media/plus-solid.f9261def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/plus-solid.svg
// module id = 666
// module chunks = 2